import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { PermissionsGuard } from './core/guards/permissions.guard';
import { Permissions } from 'src/app/core/models/permissions.enum';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule),
    },
    {
        path: 'painel',
        loadChildren: () => import('./modules/monitoring/monitoring.module').then((m) => m.MonitoringModule),
        canActivate: [AuthGuard, PermissionsGuard],
        data: {role: Permissions.TaxaComunicacao},
    },
    {
        path: 'logs',
        loadChildren: () => import('./modules/logs/logs.module').then((m) => m.LogsModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'alertas',
        loadChildren: () => import('./modules/alerts/alerts.module').then((m) => m.AlertsModule),
        canActivate: [AuthGuard, PermissionsGuard],
        data: {role: Permissions.Alertas},
    },
    {
        path: 'fila-de-monitoramento',
        loadChildren: () => import('./modules/monitoring-queue/monitoring-queue.module').then((m) => m.MonitoringQueueModule),
        canActivate: [AuthGuard, PermissionsGuard],
        data: {role: Permissions.Monitoramento},
    },
    {
        path: 'veiculos-avulsos',
        loadChildren: () => import('./modules/apart-queue/apart-queue.module').then((m) => m.ApartQueueModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'historico-posicao',
        loadChildren: () => import('./modules/position-history/position-history.module').then((m) => m.PositionHistoryModule),
        canActivate: [AuthGuard, PermissionsGuard],
        data: {role: Permissions.HistoricoPosicaoVeiculos},
    },
    {
        path: 'configuracoes',
        loadChildren: () => import('./modules/settings/settings.module').then((m) => m.SettingsModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'docs',
        loadChildren: () => import('./modules/docs/docs.module').then((m) => m.DocsModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'manutencao',
        loadChildren: () => import('./modules/maintenance/maintenance.module').then((m) => m.MaintenanceModule),
        canActivate: [AuthGuard],
        data: {role: Permissions.DispositivoManutencao},
    },
    {
        path: 'logout',
        loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule),
    },
    {
        path: '**',
        redirectTo: 'painel',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
